
import SglActions from "../common/SglActions"
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useSearchParams } from 'react-router-dom';
import SglContext from '../SglContext'
import Pagination from "../common/pagination";
import "./alllivestreams.css"


import { Link } from 'react-router-dom';
import video_icon from "../images/video_icon.png";
import VideoPlayer from "../videos/VideoPlayer";
import horse_logo from "../images/horse-logo.png";

var moment = require('moment');

function LiveStream(props) {


    // STATES
    const [special_events, setSpecial_events] = useState([])
    const [page, setPage] = useState(1)
    const [total_rows, setTotal_rows] = useState(0)
    const [timeout, setTimeout] = useState(null)
    const [loading, seTLoading] = useState(true)
    const [userData, setUserData] = useState({})
    const [PaginationElement, setPaginationElement] = useState(null);

    const Sgl = useContext(SglContext);

    const sgl_webservice_livestream_list = Sgl.nestApiUrl + '/livestream';
    const user_info_url = Sgl.nestApiUrl + '/users/getUser';

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const site_url = "//" + window.location.host;

    const [searchParams, setSearchParams] = useSearchParams()
    useEffect(() => {
        setPaginationElement(React.createRef());
    }, []);

    useEffect(() => {
        getSpecialEventsData(page);
        document.title = ("Sgl-DetailPage")
    }, [page]);

    function getSpecialEventsData(page) {
        axios.get(sgl_webservice_livestream_list + "/specialEvents", {
            params: {
                page: page,
                customer_id: Sgl.company_id
            },
        })
            .then((res) => {
                Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/specialevents/list/page/' + page);
                Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/specialevents/list/page/' + page);
                setSpecial_events(res.data.special_events)
                setTotal_rows(res.data.total_rows)
                setPage(res.data.page)
                seTLoading(false)
                // var pager = PaginationElement.current.getPager(total_rows, page, 12);
                // PaginationElement.current.setPager({ pager: pager });
            });
    }

    function getUserData() {
        axios.get(user_info_url)
            .then((response) => {
                if (response.data.user && response.data.user != null) {
                    setUserData(response.data.user)
                } else {
                }
            }, (error) => {
            });
    }


    function onChangePage(page) {
        setPage(page)
    }

    const Label = (name) => {
        if (name.length > 55) {
            let result = name.substring(0, 55);
            name = result + "..."

        }

        return name;
    }

    if (loading) {
        return null;
    }

    return (
        <div className="sgl-plugin alllivecss">
            <h1>Live Streams</h1>
            <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
            <div
                id="livestream_listing"
                className="livestream_grid"
            >
                <div id="sgl-livestream-card-container" className="flex-livestream-container">

                    {total_rows > 0 ? (
                        special_events.map((special_event, index) => {
                            let event_date = special_event.hasOwnProperty('event_date') ? new Date(special_event.event_date) : null;
                            return (
                                <div className="sgl-archive-event">
                                    <Link key={index} className="sgl-link" to={'/livestream/detail?se_id=' + special_event.sgl_id}>
                                        
                                            <img src={special_event.placeholder_image} alt="" srcSet="" />
                                            <div className="sgl-description">
                                                <div className="sgl-text">{Label(special_event.title)}</div>
                                            </div>
                                            {special_event.event_date && moment(special_event.event_date).isValid() && (
                                                <div className="sgl-badge">
                                                    <div className="sgl-badge-inner">
                                                        <span className="sgl-day">{moment(event_date).format("D")}</span>
                                                        <span className="sgl-month">{moment(event_date).format("MMM")}</span>
                                                        <span className="sgl-year">{moment(event_date).format("YYYY")}</span>
                                                    </div>
                                                </div>
                                            )}
                                    </Link>
                                </div>
                            );
                        })
                    ) : (
                        <div className="livestream_container ">
                            <div className="livestream-content">
                                <div className="thumb-image">
                                    <img src={horse_logo} />
                                    <span className="float-left">No Live Streams Found</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Pagination items={total_rows} onChangePage={onChangePage} initialPage={page} ref={PaginationElement} />
            <div><span className="link_color"><b>Showing {((page - 1) * 12) + 1} to {(page - 1) * 12 + special_events.length} of {total_rows} results.</b></span></div>
            <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </div>
    )
    // }
}
export default LiveStream